module.exports = __webpack_public_path__ + "img/appAsset--tracker-ax.ae338d0d.svg";